import React from 'react'
import classNames from 'classnames'
import './index.scss'

export interface ILoading {
  spinning?: boolean
  fullScreen?: {} | null
}

const Loading = ({ spinning = false, fullScreen = null }: ILoading) => {
  return (
    <div
      className={classNames('loader', {
        hidden: !spinning,
        fullScreen: fullScreen,
      })}
    >
      <div className="warpper">
        <div className="inner" />
        <div className="text">LOADING</div>
      </div>
    </div>
  )
}

export default Loading
